import { DateTime } from 'luxon';

export const dateColumnSort = (dateA: string, dateB: string): number => {
  const a = DateTime.fromFormat(dateA, 'dd-MM-yyyy');
  const b = DateTime.fromFormat(dateB, 'dd-MM-yyyy');

  if (a < b) {
    return -1;
  }
  if (a.equals(b)) {
    return 0;
  }
  return 1;
};
